import React from 'react';
import {
  MenuOutlined,
  UserOutlined,
  TableOutlined,
  GiftOutlined,
  SettingOutlined,
  AreaChartOutlined,
  PayCircleOutlined,
  FireOutlined,
  FileImageOutlined,
  ReadOutlined,
  WalletOutlined,
} from '@ant-design/icons';

import Home from '@/views/Home/Home';
import Board from '@/views/Board/Board';
import Stock from '@/views/New/Stock/Stock';
import Bond from '@/views/New/Bond/Bond';
import Bonus from '@/views/Bonus/Bonus';
import Daily from '@/views/Daily/Daily';
import Lottery from '@/views/Lottery/Lottery';
import UserInfo from '@/views/UserInfo/UserInfo';
import Grid from '@/views/Grid/Grid';
import Shanghai from '@/views/Setting/Shanghai/Shanghai';
import Shenzhen from '@/views/Setting/Shenzhen/Shenzhen';
import BackUp from '@/views/Setting/BackUp/BackUp';
import Log from '@/views/Setting/Log/Log';
import ExRate from '@/views/Setting/ExRate/ExRate';
import Uploader from '@/views/Uploader/Uploader';
import View from '@/views/Blog/View/View';
import Comment from '@/views/Blog/Comment/Comment';

/** 叶子菜单项（对应一个路由页面） */
export interface RouteItem {
  key: string;
  path: string;
  label: string;
  icon: React.ComponentType;
  component: React.ComponentType;
}

/** 分组菜单（包含子项） */
export interface SubMenuGroup {
  key: string;
  label: string;
  icon: React.ComponentType;
  children: RouteItem[];
}

export type MenuConfigItem = RouteItem | SubMenuGroup;

/** 判断是否为分组菜单 */
export function isSubMenu(item: MenuConfigItem): item is SubMenuGroup {
  return 'children' in item;
}

export const menuConfig: MenuConfigItem[] = [
  { key: '1', path: '/home', label: '首页', icon: MenuOutlined, component: Home },
  { key: '2', path: '/userInfo', label: '账户信息', icon: UserOutlined, component: UserInfo },
  { key: '10', path: '/board', label: '数据看板', icon: AreaChartOutlined, component: Board },
  { key: '100', path: '/grid', label: '网格', icon: TableOutlined, component: Grid },
  { key: '4', path: '/daily', label: '每日资产', icon: PayCircleOutlined, component: Daily },
  {
    key: 'sub3', label: '打新', icon: FireOutlined,
    children: [
      { key: '3.1', path: '/new/stock', label: '新股', icon: FireOutlined, component: Stock },
      { key: '3.2', path: '/new/bond', label: '新债', icon: FireOutlined, component: Bond },
    ],
  },
  { key: '6', path: '/bonus', label: '分红', icon: WalletOutlined, component: Bonus },
  { key: '5', path: '/lottery', label: '彩票', icon: GiftOutlined, component: Lottery },
  { key: '16', path: '/uploader', label: '床图', icon: FileImageOutlined, component: Uploader },
  {
    key: 'setting', label: '设置', icon: SettingOutlined,
    children: [
      { key: '66', path: '/setting/shanghai', label: '沪市', icon: SettingOutlined, component: Shanghai },
      { key: '8', path: '/setting/shenzhen', label: '深市', icon: SettingOutlined, component: Shenzhen },
      { key: '9', path: '/setting/backup', label: '数据备份', icon: SettingOutlined, component: BackUp },
      { key: 'setting004', path: '/setting/log', label: '日志', icon: SettingOutlined, component: Log },
      { key: '/exRate', path: '/setting/exRate', label: '汇率', icon: SettingOutlined, component: ExRate },
    ],
  },
  {
    key: 'blog', label: '博客', icon: ReadOutlined,
    children: [
      { key: 'blog002', path: '/blog/view', label: '文章浏览量', icon: ReadOutlined, component: View },
      { key: 'blog003', path: '/blog/comment', label: '评论', icon: ReadOutlined, component: Comment },
    ],
  },
];

/** 从配置中派生的 path → menuKey 映射 */
export const PATH_TO_KEY: Record<string, string> = {};
/** 从配置中派生的 path → subMenuKey 映射 */
export const PATH_TO_SUBMENU: Record<string, string> = {};

for (const item of menuConfig) {
  if (isSubMenu(item)) {
    for (const child of item.children) {
      PATH_TO_KEY[child.path] = child.key;
      PATH_TO_SUBMENU[child.path] = item.key;
    }
  } else {
    PATH_TO_KEY[item.path] = item.key;
  }
}
